/* USERS */
export const GET_USERGROUPS = "GET_USERGROUPS"
export const GET_USERGROUPS_SUCCESS = "GET_USERGROUPS_SUCCESS"
export const GET_USERGROUPS_FAIL = "GET_USERGROUPS_FAIL"
